module.exports = __webpack_public_path__ + "img/700_Hover.5bd16d80.png";